/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';

import { PagePermissionType } from "../models/page-permission-type";
import { PagePermissionService } from "../services/page-permission.service";
import { SystemSettingsService } from 'app/services/system-settings.service';

@Component({
    templateUrl: './home.component.html',
    styleUrls: [ './home.component.css' ]
})
export class HomeComponent implements OnInit{

  /** Link to the WOW Reports. Loaded from the Server. */
  wowReportsLink: string = null;

  pagePermissionType = PagePermissionType;
  token: string;
    
  constructor(
    public pagePermissionService: PagePermissionService,
    private systemSettingsService: SystemSettingsService
  ) { }

  /**
   * Initializes the component. 
   * Currently used to call the REST API to get the URL Link to the WOW Reports.
   */
  ngOnInit(): void {
    this.refreshWowReportLink();
  }

  /**
   * Calls the REST API to get the URL Link to the WOW Reports 
   * and updates the wowReportsLink variable. 
   */
  private async refreshWowReportLink(): Promise<void> {
    try {
      const temp = await this.systemSettingsService.getWowReportsLink();
      if (temp?.length > 0) {
        this.wowReportsLink = temp.toString();
      } else {
        this.wowReportsLink = null;
      }
      console.log(`WOW Report Link obtained! - '${this.wowReportsLink}'`);
    } catch (error) {
      console.error(`Problem obtaining WOW Report Link. Link will not work.`, error);
      this.wowReportsLink = null;
    }
  }

  /**
   * Called when the WOW Reports Link is clicked in the UI.
   * 
   * This opens the URL to the WOW Reports in a new window. 
   */
  onReports(): void {
    if (this?.wowReportsLink?.length > 0) {
      window.open(this.wowReportsLink, "_blank");
    } else {
      console.error("Missing 'WOW Reports Link' setting.");
    }
  }

}
